import styled from 'styled-components';

// Material-UI
import MenuItem from '@material-ui/core/MenuItem';
import ListSubheader from '@material-ui/core/ListSubheader';

// *************************************
// STYLED COMPONENTS                           
// *************************************

// Menu Item
export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    padding: 0px; 
    white-space: normal;
    color: ${(props) => props.theme.colors.greyDark};
  }
`;

// Menu Header
export const StyledMenuHeader = styled(ListSubheader)`
  &.MuiListSubheader-root { 
    height: 50px;
    padding: 0 16px;
    white-space: normal;
    color: ${(props) => props.theme.colors.greyDark};
    background-color: ${(props) => props.theme.colors.white};
    border-bottom: 1px solid ${(props) => props.theme.colors.greyLight};
  }
`;
